import { createRef, Component } from 'react';
import autoBind from 'react-autobind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';

import { trendingPeriodFormatter } from '../../../utils/trendingBarHelper';
import * as trendingActions from '../../../actions/trendingBarActions';
import WatchlistModal from '../../Modals/WatchlistModal';
import TrendingTopicItem from '../TrendingTopicItem';
import TrendingFiltersDropDown from '../TrendingFiltersDropDown';
import TrendingGraphDropDown from '../TrendingGraphDropDown';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';
import PlayVideoComponent from '../../PlayVideoComponent';

let story = [[0, 0]];

class TrendingBarInner extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.list = null;
    this.leftBtn = null;
    this.rightBtn = null;
    this.stripContainer = null;
    this.movingBlock = null;
    this.listItems = [];
    this.listItemRef = createRef();
    this.state = {
      listWidth: 0,
      allowedWidth: 0,
      width: 0,
      selectedTrendingClassesNames: '',
      openModal: false,
      selectedTopic: {},
      initialLoad: true,
      activeTopicItem: null,
    };
  }

  componentDidMount() {
    const { actions, period, selectedTrendingClasses } = this.props;

    const assetIds = selectedTrendingClasses.map((asset) => asset.id);
    if (assetIds.length > 0) {
      actions.onLoadAssets(period, assetIds.join(','));
    } else {
      actions.onLoadAssets(period);
    }
    actions.loadTrendingAssetsFilters();
    setTimeout(() => {
      if (this.movingBlock) {
        this.movingBlock.style.left = '0px';
        this.movingBlock.dataset.position = '0';
        this.setState({
          listWidth: this.stripContainer.offsetWidth,
          allowedWidth: parseInt(this.stripContainer.offsetWidth - 388, 10),
          width: window.offsetWidth,
          initialLoad: false,
        }, () => this.checkButtonsVisibility());
      }
    }, 500);
    window.addEventListener('resize', this.handleTrendingStripResize);
  }

  componentDidUpdate(prevProps) {
    const {
      selectedTrendingClasses,
      period,
      userPreferences,
    } = this.props;

    if (
      selectedTrendingClasses.length !== prevProps.selectedTrendingClasses.length
      || period !== prevProps.period
    ) {
      setTimeout(() => {
        this.checkButtonsVisibility();
        this.trendingAssetsNameCutter();
      }, 100);
      story = [[0, 0]];
      if (this.movingBlock) {
        this.movingBlock.style.left = '0px';
        this.movingBlock.dataset.position = '0';
      }
    }

    if ((prevProps.userPreferences.show_trending_asset_bar
      !== userPreferences.show_trending_asset_bar)
      && !userPreferences.show_trending_asset_bar) {
      story = [[0, 0]];
      setTimeout(() => {
        if (this.movingBlock) {
          this.movingBlock.style.left = '0px';
          this.movingBlock.dataset.position = '0';
          this.setState({
            listWidth: 0,
            allowedWidth: 0,
            width: 0,
            initialLoad: false,
          }, () => this.checkButtonsVisibility());
        }
      }, 500);
    }

    if ((prevProps.userPreferences.show_trending_asset_bar
      !== userPreferences.show_trending_asset_bar)
      && userPreferences.show_trending_asset_bar) {
      story = [[0, 0]];
      setTimeout(() => {
        if (this.movingBlock) {
          this.movingBlock.style.left = '0px';
          this.movingBlock.dataset.position = '0';
          this.setState({
            listWidth: this.stripContainer.offsetWidth,
            allowedWidth: parseInt(this.stripContainer.offsetWidth - 388, 10),
            width: window.offsetWidth,
            initialLoad: false,
          }, () => this.checkButtonsVisibility());
        }
      }, 500);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleTrendingStripResize);
  }

  // eslint-disable-next-line react/sort-comp
  nextTrendingTopics() {
    const { allowedWidth } = this.state;

    if (!this.list.childNodes.length) return;

    let point = 0;
    const currentPosition = parseInt(this.movingBlock.dataset.position, 10);
    const lastStory = story[story.length - 1];
    let i = lastStory[0];

    for (let lim = this.list.childNodes.length; i < lim; i += 1) {
      const addingValue = parseInt(this.list.childNodes[i].offsetWidth, 10);
      if ((point + addingValue) <= allowedWidth) {
        point += addingValue;
      } else {
        break;
      }
    }
    this.movingBlock.style.left = `${currentPosition - point + 40}px`;
    this.movingBlock.dataset.position = (currentPosition - point);
    story.push([i, point]);
    this.checkButtonsVisibility();
  }

  prevTrendingTopics() {
    const lastStory = story.pop();
    const point = lastStory[1];
    const currentPosition = parseInt(this.movingBlock.dataset.position, 10);

    if (story.length === 1) {
      this.movingBlock.style.left = `${0}px`;
    } else {
      this.movingBlock.style.left = `${currentPosition + point + 40}px`;
    }
    this.movingBlock.dataset.position = (currentPosition + point);
    this.checkButtonsVisibility();
  }

  countLengthToTheEnd() {
    const { allowedWidth } = this.state;

    if (!this.list) return;

    const lastStory = story[story.length - 1];
    let howManyleft = 0;
    let i = lastStory[0];
    for (let lim = this.list.childNodes.length; i < lim; i += 1) {
      howManyleft += parseInt(this.list.childNodes[i].offsetWidth, 10);
    }
    return howManyleft <= allowedWidth;
  }

  checkButtonsVisibility() {
    const { listWidth, allowedWidth } = this.state;
    const { selectedTrendingClasses, trendingAssets } = this.props;

    if (!this.leftBtn) return;

    if (listWidth <= (allowedWidth + 30)) {
      this.leftBtn.classList.remove(`${Styles.visible}`);
      this.rightBtn.classList.remove(`${Styles.visible}`);
    } else {
      this.leftBtn.classList.add(`${Styles.visible}`);
      this.rightBtn.classList.add(`${Styles.visible}`);
      if (story.length === 1) {
        this.leftBtn.classList.remove(`${Styles.visible}`);
      } else {
        this.leftBtn.classList.add(`${Styles.visible}`);
      }
      if (this.countLengthToTheEnd()) {
        this.rightBtn.classList.remove(`${Styles.visible}`);
      } else {
        this.rightBtn.classList.add(`${Styles.visible}`);
      }

      if (
        selectedTrendingClasses.length === 0
        || trendingAssets.length === 0
      ) {
        this.rightBtn.classList.remove(`${Styles.visible}`);
      }
    }
  }

  handleTrendingStripResize() {
    let trendingStripWidth = parseInt(this.stripContainer.offsetWidth - 388, 10);
    if (document.documentElement.clientWidth < 768) {
      trendingStripWidth += 46;
    }

    this.setState({
      allowedWidth: trendingStripWidth,
    });
  }

  handleCloseModal() {
    this.setState({
      openModal: false,
    });
    const { activeTopicItem } = this.state;
    this.handleActiveTrendingTopicItem(activeTopicItem, false);
  }

  showWatchlistModal(topic) {
    const { openModal } = this.state;

    this.setState({
      openModal: !openModal,
      selectedTopic: topic,
    });
  }

  toggleDropDown(e) {
    const { actions } = this.props;
    const { activeTopicItem } = this.state;
    this.handleActiveTrendingTopicItem(activeTopicItem, false);

    e.stopPropagation();
    setTimeout(() => {
      actions.toggleTrendingFilters();
    }, 1);
  }

  trendingAssetsNameCutter() {
    const { selectedTrendingClasses } = this.props;

    const allAssetsString = selectedTrendingClasses.map((asset) => asset.title);
    this.setState({ selectedTrendingClassesNames: `${allAssetsString.join(', ').substring(0, 15)}...` });
  }

  handleActiveTrendingTopicItem(id, status) {
    const { activeTopicItem } = this.state;
    const { actions } = this.props;

    if (status) {
      this.setState({
        activeTopicItem: id,
      });
      actions.toggleActiveTrendingBarTopic(true);
    } else if (id === activeTopicItem) {
      this.setState({
        activeTopicItem: null,
      });
      actions.toggleActiveTrendingBarTopic(false);
    }
  }

  cancelOpenTrendings(e) {
    e.stopPropagation();
  }

  render() {
    const {
      trendingAssets,
      period,
      allTrendingAssetClasses,
      userPreferences,
      trendingGraphOpened,
      trendingBarFiltersOpened,
      user,
      piwikEnabled,
    } = this.props;

    const {
      activeTopicItem,
      selectedTopic,
      selectedTrendingClassesNames,
      width,
      openModal,
      initialLoad,
    } = this.state;
    const angle = <FontAwesomeIcon icon={trendingBarFiltersOpened ? faAngleUp : faAngleDown} />;

    return (
      <div className={Styles.trending_bar_inner}>
        <div className={Styles.trending_inner_left} onClick={this.toggleDropDown}>
          <div className={Styles.trending_title}>
            <strong>Trending</strong>
            <div className={Styles.period_wrapper}>
              <span>
                {trendingPeriodFormatter(period)}
                ,
                {' '}
              </span>
              <span>{allTrendingAssetClasses ? 'All Classes' : selectedTrendingClassesNames}</span>
            </div>
          </div>
          <div onClick={this.cancelOpenTrendings}>
            <PlayVideoComponent
              videoLink="https://cityfalcon.wistia.com/medias/be7nogrmi6"
              additionalStyles={Styles.trending_bar_active_play_button}
              renderOutside
            />
          </div>
          {angle}
        </div>
        {trendingBarFiltersOpened && userPreferences.show_trending_asset_bar && (
          <TrendingFiltersDropDown piwikEnabled={piwikEnabled} />
        )}
        {trendingGraphOpened && userPreferences.show_trending_asset_bar && (
          <TrendingGraphDropDown width={width} />
        )}
        <div
          className={Styles.strip_container_wrapper}
          ref={(ref) => { this.stripContainer = ref; }}
        >
          <div
            onClick={this.prevTrendingTopics}
            ref={(ref) => { this.leftBtn = ref; }}
            className={`${Styles.trending_btn}`}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>
          <div className={Styles.trending_strip_container}>
            <div className={Styles.moving_block} ref={(ref) => { this.movingBlock = ref; }}>
              {trendingAssets.length ? (
                <ul className="d-flex" ref={(ref) => { this.list = ref; }}>
                  { /* eslint-disable-next-line no-return-assign */}
                  {trendingAssets.map((trendingAsset, index) => (
                    <TrendingTopicItem
                      ref={this.listItems[index] = this.listItemRef.current}
                      key={trendingAsset.id}
                      fullTopic={trendingAsset}
                      user={user}
                      openWathclistModal={this.showWatchlistModal}
                      openModal={openModal}
                      piwikEnabled={piwikEnabled}
                      handleActiveTrendingTopicItem={this.handleActiveTrendingTopicItem}
                      period={period}
                      activeTopicItem={activeTopicItem}
                      {...trendingAsset}
                    />
                  ))}
                </ul>
              ) : (
                !initialLoad && !trendingAssets.length && (
                  <div className={Styles.no_trending_message}>
                    No trending assets at this moment for the chosen time period
                  </div>
                )
              )}
            </div>
          </div>
          <div
            onClick={this.nextTrendingTopics}
            ref={(ref) => { this.rightBtn = ref; }}
            className={`${Styles.trending_btn} ${Styles.right_trending_btn}`}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </div>
        </div>
        {selectedTopic.name && openModal && (
          <WatchlistModal
            openModal={openModal}
            handleCloseModal={this.handleCloseModal}
            topic={selectedTopic}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...trendingActions }, dispatch),
});

const mapStateToProps = (state) => ({
  assetClasses: state.trendingBarReducer.assetClasses,
  trendingAssets: state.trendingBarReducer.trendingAssets,
  period: state.trendingBarReducer.period,
  allTrendingAssetClasses: state.trendingBarReducer.defaultTrendingClass,
  userPreferences: state.userPreferencesReducer.preferences,
  trendingGraphOpened: state.trendingBarReducer.trendingGraphOpened,
  trendingBarFiltersOpened: state.trendingBarReducer.trendingBarFiltersOpened,
  selectedTrendingClasses: state.trendingBarReducer.selectedTrendingClasses,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(TrendingBarInner),
);
